module.exports = __webpack_public_path__ + "img/bookings.c7109208.png";